// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","modal":"modal_modal__2uhXU","close":"modal_close__biV2s"};